/**
 * Utility functions for PWA (Progressive Web App) detection and behavior
 */

/**
 * Checks if the app is currently running as an installed PWA
 * This checks various conditions that indicate standalone mode
 * @returns {boolean} - Whether app is running as PWA
 */
export const isPwaMode = (): boolean => {
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  const isIosPwa = (window.navigator as any).standalone === true; // iOS-specific
  const isAndroidPwa = document.referrer.includes('android-app://');
  
  return isStandalone || isIosPwa || isAndroidPwa;
};

/**
 * Set up a listener for PWA mode changes (when installed or uninstalled)
 * @param {Function} callback - Function to call when PWA mode changes
 * @returns {Function} - Function to remove the event listener
 */
export const onPwaModeChange = (callback: (isPwa: boolean) => void): (() => void) => {
  const mediaQuery = window.matchMedia('(display-mode: standalone)');
  
  const listener = (e: MediaQueryListEvent) => {
    callback(e.matches);
  };
  
  mediaQuery.addEventListener('change', listener);
  
  // Return cleanup function
  return () => {
    mediaQuery.removeEventListener('change', listener);
  };
};

/**
 * Get an appropriate name for the current mode (PWA or browser)
 * @returns {string} - Name of the current mode
 */
export const getAppModeName = (): string => {
  if (isPwaMode()) {
    return 'StitchFlo App';
  }
  return 'StitchFlo (Browser)';
}; 